<template>
	<div class="text-center">
		<div :class="{ 'py-6': $vuetify.breakpoint.mdAndUp, 'py-5': $vuetify.breakpoint.smAndDown }"></div>
		<div class="check-mark-wrapper">
			<div class="check-mark-inner">
				<v-icon class="check-mark-icon" size="100px" color="#39b54a">mdi-check-circle</v-icon>
			</div>
		</div>
		<div :class="{ 'py-5': $vuetify.breakpoint.mdAndUp, 'py-2': $vuetify.breakpoint.smAndDown }"></div>

		<CategoryCard
			:category="categorySelected"
			:hideRuleTags="true"
			:step="3"
			class="mx-auto"
			:totalSessions="categorySelected.sessions.length"
		/>
		<div :class="{ 'py-5': $vuetify.breakpoint.mdAndUp, 'py-2': $vuetify.breakpoint.smAndDown }"></div>
		<v-btn class="actionButton mb-2" dark large @click="toCategoryDetail" :loading="loading">Mon espace perso</v-btn>
		<p class="ortho-description mt-2">Dès {{ dateDisplay }}, tu recevras ta première session dans tes mails !</p>
	</div>
</template>

<script>
import moment from 'moment';
import CategoryCard from '@/components/reports/category/CategoryCard.vue';

export default {
	name: 'ChooseChapterStep3',
	components: { CategoryCard },
	props: { categorySelected: Object },
	data() {
		return { loading: false };
	},
	computed: {
		dateDisplay() {
			if (moment().format('e') == 5 || moment().format('e') == 6) return 'lundi';
			else return 'demain';
		},
	},
	methods: {
		async toCategoryDetail() {
			this.loading = true;

			this.$router.push({
				name: 'Topic Dashboard Chapter Detail',
				params: {
					formationId: this.$route.params.formationId,
					idParcours: this.categorySelected.parcours_id,
					idCategory: this.categorySelected._id,
				},
			});
			this.loading = false;
		},
	},
};
</script>

<style lang="scss" scoped>
.check-mark-wrapper {
	height: 100px;
	width: 100%;

	.check-mark-inner {
		background: white;
		width: 80px;
		height: 80px;
		margin: 0 auto;
		position: relative;
		border-radius: 50%;
	}
	.check-mark-icon {
		position: absolute;
		left: -10px;
		top: -10px;
	}
}

.actionButton {
	font-size: 20px;
}

@media screen and (max-width: 600px) {
	.actionButton {
		font-size: 15px;
	}
}
</style>
